import React from 'react';
import { usePricing } from '../contexts/PricingContext';

export const LiquidityDisplay = () => {
  const { bidAskSpread, volume24h } = usePricing();

  const formatNumber = (num) => {
    if (!num) return '0';
    return Number(num).toLocaleString('en-US', { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    });
  };

  return (
    <div className="bg-atticus-navy-900 border-b border-atticus-navy-700 px-6 py-3">
      <div className="flex items-center justify-center space-x-8 text-sm">
        <div className="flex items-center space-x-2">
          <span className="text-gray-400">Spread:</span>
          <span className="text-green-400 font-medium">${formatNumber(bidAskSpread || 0.10)}</span>
        </div>
        
        <div className="flex items-center space-x-2">
          <span className="text-gray-400">24h Volume:</span>
          <span className="text-white font-medium">{formatNumber(volume24h || 8730)} BTC</span>
        </div>
      </div>
    </div>
  );
};
